// extracted by mini-css-extract-plugin
module.exports = {"upDownButton":"up_down_button_style_upDownButton__1tX7k","upButton":"up_down_button_style_upButton__S6FaA","downButton":"up_down_button_style_downButton__WqNrV"};